import { api } from './queryInterceptors';

import type { AxiosResponse } from 'axios';
import type { Login, LoginRequest } from '@/types/auth';

/**
 * Attempt to log in by posting a LoginRequest object to the API and receiving a Login object in response.
 *
 * @param loginRequest - The current state of the LoginRequest parameters.
 * @returns A Promise resolving to the Axios response containing a Login object.
 */
export async function loginPostQuery(loginRequest: LoginRequest): Promise<AxiosResponse<Login>> {
  const requestOptions = {
    method: 'POST',
    url: `/logins/`,
    data: {
      ...loginRequest,
      expand: 'loginCode.customIdField'
    }
  };
  return api(requestOptions);
}

/**
 * Retrieve info associated with a previously existing login
 *
 * @param {string} loginId - UUID of the login session to retrieve from the API
 * @returns - A Promise resolving to the Axios response containing a Login object.
 */
export async function loginGetQuery(loginId: string): Promise<AxiosResponse<Login>> {
  const requestOptions = {
    method: 'GET',
    url: `/logins/${loginId}/`,
    params: {
      expand: 'loginCode.customIdField'
    }
  };
  return api(requestOptions);
}